// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)

export class OutageEventTMO {
	public id: string = undefined;
	public tenantId: string = undefined;
	public businessPremisesId?: string = undefined;
	public status?: OutageEventStatusEnum = undefined;
	public createdBy?: string = undefined;
	public createdDate?: Date = undefined;
	public lastModifiedBy?: string = undefined;
	public lastModifiedDate?: Date = undefined;
	public reason?: string = undefined;
	public reportDate?: Date = undefined;
	public fccId: string = undefined;
	public tssSerialNumber?: string = undefined;
	public totalOutageSeconds?: number = undefined;
	public firstFailedTime?: Date = undefined;
	public lastFailedTime?: Date = undefined;
}

export class OutageEventBodyTMO {
	public reason?: string = undefined;
}

export class TaskOutageBusinessPremisesCountTMO {
	businessPremisesId?: string = undefined;
	count?: number = undefined;
}

export class TaskOutageBusinessPremisesTMO extends TaskOutageBusinessPremisesCountTMO {
	businessPremisesName?: string = undefined;
	outagesList?: OutageEvent[] = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class OutageEvent extends OutageEventTMO {
	public etag?: string = undefined;
}

export class TaskOutageBusinessPremises extends TaskOutageBusinessPremisesTMO {}


// INTERFACES ########################################################
// API interfaces ****************************************************


// UI interfaces *****************************************************
export interface IOutagesEntityActionEvent {
	outage: OutageEvent;

	action: OutageEntityActionEventEnum;
}

// TYPES #############################################################
export type OutageProps = ( keyof OutageEvent )[];
export type OutagePropKeys = string[];

// ENUMS #############################################################
// API enums *********************************************************
export enum OutageEventStatusEnum {
	DRAFT = 'draft',
	FINAL = 'final',
	VERIFIED = 'verified'
}

// UI enums *********************************************************
export enum OutageEntityActionEventEnum {
	NAVIGATE_TO_DETAIL_PAGE = 'navigateToDetailPage',
	NAVIGATE_TO_FORM_UPDATE = 'navigateToFormUpdate'
}
